export default {
    methods: {
        openWindow(route) {
            let resolvedRoute = this.$router.resolve(route);
            window.open(resolvedRoute.href, '_blank');
        },
    },
};
